import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth.store';
import settings from './settings.store';
import projects from './projects.store';
import clients from './clients.store';
import global from './global.store';
import task from './task.store';
import teams from './teams.store';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    task,
    teams,
    clients,
    global,
    settings,
    projects,
  },

  state: {},
  mutations: {},
  actions: {},
});
